const appConfig = {
  apiPrefix: "/api",
  authenticatedEntryPath: "/home",
  unAuthenticatedEntryPath: "/home",
  tourPath: "/",
  enableMock: true,
  ambient: "dev",
};

export default appConfig;
